import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class BottomHandle extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'bottom_handle';
    this.partName = 'Bottom Handle';
    this.translateId = "visualizer.kitchen.cabinet.bottom_handle";
    this.canBeDisabled = true;
    this.layerPriority = 5;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["CabinetLayout"]) {
      dbFeature.metaData["CabinetLayout"] = ["All"]
    }
    if (!dbFeature.metaData["DoorSet"]) {
      dbFeature.metaData["DoorSet"] = ["All"]
    }
    if (!dbFeature.metaData["Appliance"]) {
      dbFeature.metaData["Appliance"] = ["All"]
    }
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new BottomHandle(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new BottomHandle());
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const bottomCabinet = this.getParent().bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {
    const cabinetParent = this.getParent();
    let cabinetLayout = ["All"];
    let doorSet = ["All"];
    if (cabinetParent.bottomCabinet && cabinetParent.bottomCabinet.activeFeature) {
      if (cabinetParent.bottomCabinet.activeFeature.metaData["CabinetLayout"]) {
        cabinetLayout = cabinetParent.bottomCabinet.activeFeature.metaData["CabinetLayout"][0]
      }
      if (cabinetParent.bottomCabinet.activeFeature.metaData["DoorSet"]) {
        doorSet = cabinetParent.bottomCabinet.activeFeature.metaData["DoorSet"][0];
      }
    }
    return [{
      propName: "Appliance",
      propValue: cabinetParent.getBottomCabinetApplianceType()
    }, {
      propName: 'RoomLayout',
      propValue: cabinetParent.layout.getCurrentLayoutAbbreviation()
    },{
      propName: 'CabinetLayout',
      propValue: cabinetLayout
    },{
      propName: "DoorSet",
      propValue: doorSet
    }];
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const matchingFeatureExist = this.tryToSetTheSameFeature(filteredFeatures, null);
    if (!matchingFeatureExist) {
      this.activeFeature = filteredFeatures[0];
    }
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions()
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      const zIndex = zIndexes.Cabinet.BottomHandle;
      const zIndex2 = zIndexes.Cabinet.BottomHandle2;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            activeFeaturePart.layer.zIndex = zIndex2;
          }
        })
      }
    }
  }
}
